<script lang="ts">
	import { cn } from "#lib/web-ui/ui/utils.js";

	interface Props {
		label?: string;
		title?: string;
		subtitle?: string;
		align?: "center" | "left";
		class?: string;
	}

	let { label, title, subtitle, align = "center", class: className }: Props = $props();
</script>

{#if label || title || subtitle}
	<div class={cn("mb-16", align === "center" && "mx-auto max-w-2xl text-center", className)}>
		{#if label}
			<p class="text-primary text-xs font-semibold tracking-[0.2em] uppercase">{label}</p>
		{/if}
		{#if title}
			<h2 class="text-foreground mt-2 text-3xl font-semibold tracking-tight sm:text-4xl">
				{title}
			</h2>
		{/if}
		{#if subtitle}
			<p class="text-muted-foreground mt-6 text-lg">{subtitle}</p>
		{/if}
	</div>
{/if}
